






























import Vue from 'vue'
import PlannedNotifications from '@/components/Notifications/PlannedNotifications.vue'
import ManageNotifications from '@/components/Notifications/ManageNotifications.vue'
import InfoGuideDialog from '@/components/Global/InfoGuideDialog.vue'

export default Vue.extend({
  name: 'Notifications',
  components: {
    ManageNotifications,
    PlannedNotifications,
    InfoGuideDialog
  },
  data () {
    return {
      infoGuideDialogOpened: false
    }
  }
})

